/** @module ProductSpec/SizeChart/ProductGroup */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/ActionData",
	"csi/heading/Ref",
], function(declare,lang,Action,ViewRef,ActionData,Ref) {

	/**
	 * This module is renderer for
	 * ProductSpec.xml
	 * Node = SizeChartRevision
	 * Heading Id="Group"
	 * View Widget = "ProductSpec/SizeChart/ProductGroupView"
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Product Group" tooltip "Edit"
	 */

	return declare(Ref, {
		tagAction: "ActionProductGroup",

		/**
		 * @override
		 * Provide "Go To Dialog" for Product Group drop down
		 */
		_getStoreAction: function(ctx, h) {
			return lang.mixin(new Action(), {
				m_viewRef: lang.mixin(new ViewRef(), {
					m_url: "centric://APPAREL/SizeChartAdmin",
					m_id: "AggregateProductGroup"
				})
			});
		}

	});
});